<template>
  <div class="newList">
    <!-- 顶部导航 -->
    <div class="nav">
      <van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
      <span>家具头条</span>
      <div></div>
    </div>
    <!-- 轮播图 -->
    <div class="content">
      <van-swipe :autoplay="3000" indicator-color="white" :height="120">
        <van-swipe-item v-for="item in imgList">
          <img :src="item" alt="">
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- 列表 -->
    <div class="list">
      <div class="list_top">最新资讯</div>
      <div class="list_msg">
        <van-list :finished="finished" v-model="loading" finished-text="我是有底线的" @load="onLoad">
          <van-cell :to="{name: 'information', query: {id: item.id}}" v-for="(item,index) in newList" :class="{'lin_heade':index != newList.length-1}">
            <template slot="title">
              <div class="list_title">
                <div class="list_title_left">
                  <span class="font_8">{{item.d}}</span>
                  <span>{{item.create_time}}</span>
                </div>
                <div class="list_title_right">
                  <div class="list_title_right_title">{{item.title}}</div>
                  <div class="list_title_right_msg">浏览量: {{item.browse}}</div>
                </div>
              </div>
            </template>
          </van-cell>
        </van-list>
      </div>
    </div>
    <Footbar></Footbar>
  </div>
</template>

<script>
  import Footbar from '@/components/footbar'

  export default {
    data() {
      return {
        imgList: [
          require('../../../assets/class.png'),
          require('../../../assets/class.png'),
          require('../../../assets/class.png'),
          require('../../../assets/class.png')
        ],
        newList: [],
        loading: false,
        finished: false,
        pages: 1
      }
    },
    components: {
      Footbar
    },
    methods: {
      onLoad() {
        //新闻列表
        this.$axios.post(baseUrl + '/mobile/Base/news', {
          limit: 10,
          page: this.pages
        }).then((res) => {
          console.log(res)
          if (res.data.code == 2) {
            this.pages++;
            setTimeout(() => {
              for (var i in res.data.data['tt']) {
                this.newList.push(res.data.data['tt'][i]);
              }
              // 加载状态结束
              this.loading = false;
            }, 500)
          } else {
            this.loading = false;
            this.finished = true;
          }
        }).catch((err) => {
          console.log(err);
        });
      }
    }
  }
</script>

<style scoped>
  @import "newList.css";
</style>



// WEBPACK FOOTER //
// src/components/min/about/newList.vue